module.exports = __webpack_public_path__ + "img/samurai.d784a962.jpg";